import React from 'react';
import { View, } from 'react-native';
import PaginationRender from "./PaginationRender";
import {ButtonImage} from "../../../../components";

const PaginationController = ({ elements, selectedIndex, onMoveLeft, onMoveRight }) => {

    return (
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>

            <ButtonImage
                onPress={onMoveLeft}
                imageSource={require('../../../../img/icons/arrowIconLeft.png')}
                imagePropsStyle={{ height: 32, width: 32 }}
            />

            <View style={{ flexDirection:  'row', width: '80%', alignItems: 'center', justifyContent: 'center' }}>
                {
                    elements.map((item, index) => {
                        return <PaginationRender key={index} userSelectedIndex={item.userSelectedIndex} index={index} selectedIndex={selectedIndex} />
                    })
                }
            </View>

            <ButtonImage
                onPress={onMoveRight}
                imageSource={require('../../../../img/icons/arrowIconRight.png')}
                imagePropsStyle={{ height: 32, width: 32 }}
            />

        </View>
    )

}

export default PaginationController;
